/**
 * Where an overlay surface's DOM node lives.
 *
 * An overlay is portalled to the top of the document so it can cover the page.
 * That is right for the one search a site has, and wrong as soon as a page hosts
 * more than one: two overlays fight over the same target, and an overlay meant
 * to demonstrate a shape inside a panel blacks out everything around it.
 *
 * Per decision #5067 a scoped overlay moves where the node lives and nothing
 * else -- not the shape, and not whether the overlay is open.
 *
 * @param {Element|null} target - the placement's portal target, if it has one
 * @returns {Element|null} the element to portal into
 */
export function overlayPortalTarget(target) {
  if (typeof document === 'undefined') return null;
  return isScopedOverlay(target) ? target : document.body;
}

/**
 * Whether an overlay lands somewhere other than document.body.
 *
 * This is decision #5064's test applied to the overlay: an element reaches the
 * head-injected vo-search.css only if it portals out to the light DOM. A scoped
 * overlay does not, so it has to carry its own mirrored rules -- and an unscoped
 * one must not, or every open would ship a second zero-specificity copy of the
 * stylesheet in front of the customer's own.
 *
 * @param {Element|null} target - the placement's portal target, if it has one
 * @returns {boolean} true when the target can host the overlay
 */
export function isScopedOverlay(target) {
  return Boolean(target && typeof target.appendChild === 'function' && target.nodeType === 1);
}
